<script setup>
import { register } from 'swiper/element/bundle';
import { onMounted, ref } from 'vue';

const props = defineProps(['companies'])

const companies = ref(JSON.parse(props.companies));

const companySlider = ref();

const companySliderParams = {
  loop: true,
  speed: 500,
  spaceBetween: 50,
  navigation: true,
  grabCursor: true,

  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    640: {
      slidesPerView: 4,
    },
    768: {
      slidesPerView: 5,
    },
    1280: {
      slidesPerView: 7,
    },
  },
};

onMounted(() => {
  register();
  Object.assign(companySlider.value, companySliderParams);
  companySlider.value.initialize();
})
</script>

<template>
  <swiper-container class="tw-mx-auto sm:tw-pt-0 tw-px-24 md:tw-pr-0 tw-grid" init="false" ref="companySlider">

    <swiper-slide v-for="(company, index) in companies " :key="index" class="tw-h-full tw-flex tw-items-center">
      <a :href="'/unternehmen/profile/' + company.id" class="!tw-no-underline tw-group">
        <img class="tw-w-full" :src="'/images/companys/cropped-' + company.logo" :alt="company.company.name">
      </a>
    </swiper-slide>

  </swiper-container>
</template>
